module.exports = __webpack_public_path__ + "img/SH2D_30009.99c05d13.png";